import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { View, Table, Spin } from '@components';
import { momentToDate, formatDecimal } from '@utils';
import { getColorReference, getLinkProcesso } from '../../rules';
import { getProcessosByLote } from '@ducks/logsTempos';

import styled from 'styled-components';

const TableStyled = styled(Table)`
  .ant-table-row {
    cursor: pointer;
  }
`;

const ViewDados = styled(View)`
  font-size: 20px;
  margin-bottom: 30px;
`;

const ViewDuracao = styled(View)`
  padding: 0px 10px;
  border-radius: 10px;
  background-color: ${(props) => props.bgColor};
  color: #ffffff;
  font-weight: bold;
  margin: 0 10px;
`;

const ViewLegendas = styled(View)`
  padding: 10px;
  border: 1px solid #cccccc;
  width: fit-content;
  margin: 10px;
  border-radius: 10px;
`;

export default function ProcessosByLoteIndicadores() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { lote } = useParams();

  const processosByLote = useSelector(({ logsTempos }) => logsTempos.get('processosByLote').toArray());
  const loadingProcessosByLote = useSelector(({ logsTempos }) => logsTempos.get('loadingProcessosByLote'));

  const handleSearch = () => {
    dispatch(getProcessosByLote({ lote }));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Visualização',
      dataIndex: 'idVisualizacao',
      key: 'idVisualizacao',
    },
    {
      title: 'Início',
      dataIndex: 'start',
      key: 'start',
      align: 'center',
      render: (text) => momentToDate(text),
    },
    {
      title: 'Fim',
      dataIndex: 'end',
      key: 'endDate',
      align: 'center',
      render: (text) => momentToDate(text),
    },
    {
      title: 'Duração (s)',
      dataIndex: 'duration',
      key: 'duration',
      align: 'center',
      render: (text) => (
        <View alignItems='center'>
          <ViewDuracao bgColor={getColorReference(text)}>{formatDecimal(text / 1000, { minDec: 3, maxDec: 3 })}</ViewDuracao>
        </View>
      ),
    },
  ];

  const handleSelection = (data) => {
    history.push(`/analise-desempenho/processos-web/${data.id}`);
  };

  return (
    <View>
      <View alignItems='center'>
        <ViewLegendas horizontal>
          <ViewDuracao bgColor={getColorReference(999)}>&lt; 1s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(2499)}>&lt; 2.5s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(4999)}>&lt; 5s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(5000)}>&gt;= 5s</ViewDuracao>
        </ViewLegendas>
      </View>
      <View>
        {processosByLote.length > 0 ? (
          <View>
            <ViewDados>
              <View>Cliente: {processosByLote[0].customer}</View>
              <View>
                Usuário: {processosByLote[0].userName} ({processosByLote[0].userId})
              </View>
              <View>{getLinkProcesso(processosByLote[0].url)}</View>
            </ViewDados>
            <TableStyled
              rowKey='id'
              columns={columns}
              dataSource={processosByLote}
              loading={loadingProcessosByLote}
              hidePagination
              onRow={(data) => {
                return {
                  onClick: () => {
                    handleSelection(data);
                  },
                };
              }}
            />
          </View>
        ) : (
          <Spin />
        )}
      </View>
    </View>
  );
}
